
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl, FormGroupDirective } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ISubscription, Subscription } from 'rxjs/Subscription';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Subject } from 'rxjs';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { HttpService } from '../../../services/http/http.service';
import { CampaignServiceService } from 'src/app/services/campaign-service.service';
import { CampaignService } from 'src/app/services/campaign/campaign.service';
import { UtilityService } from 'src/app/services/utility/utility.service';
import { DriveService } from 'src/app/services/drive/drive.service';

@Component({
  selector: 'app-invitation-form',
  templateUrl: './invitation-form.component.html',
  styleUrls: ['./invitation-form.component.scss']
})
export class InvitationFormComponent implements OnInit {
  jobApplication: FormGroup;
  spinner = false;
  data: any = {};
  locRegex = new RegExp('^[a-zA-Z ]*$');
  cid;
  digitExp = '^([1-9])+[0-9]*$';
  nameExp = '[a-zA-Z ]*$';
  // gender = "";
  graduationYear = [];
  currentQualification;
  qualificationArray = ['BE', 'ME', 'MCA', 'BTECH', 'MTECH', 'MSC', 'Others'];
  currentYear = new Date().getFullYear();
  qualification = new FormControl(null, [Validators.required, Validators.pattern(this.nameExp), this.noWhitespaceValidator]);
  interviewMessage = "";
  interviewAddress = "";
  referralType = "";
  id: any;
  campaignShortName: any = 'Facebook';
  displayFlag: boolean = false;
  isHiringDrive: boolean = false;
  campPurpose: any;
  showStatusOfOtpField: boolean = false;
  otpResendStatus: boolean = false;

  constructor(private fb: FormBuilder, public route: ActivatedRoute,
    public snackBar: MatSnackBar, public dialog: MatDialog,
    private router: Router, private spinnerService: Ng4LoadingSpinnerService,
    private campaignService: CampaignService,
    private utilityService: UtilityService,
    private driveService: DriveService
  ) {
    this.route.queryParams.subscribe(params => {
      this.cid = params['cid'];
      this.referralType = params['referralType'];

    })
  }


  ngOnInit() {
    // this.getCampaingData();
    this.campaignShortName = this.route.snapshot.paramMap.get('shortName');
    console.log("shortname fetched: ", this.campaignShortName);
    this.getCampaignData();
    for (var i = this.currentYear; i >= 2011; i--) {
      this.graduationYear.push(i);
    }
    this.jobApplication = this.fb.group({
      fullName: [null, Validators.compose([Validators.required, Validators.minLength(2),
      Validators.pattern('[a-zA-Z ]*$')])],
      email: [null, Validators.compose([Validators.required, Validators.maxLength(50), Validators.pattern(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)])],

      phoneno: [null, Validators.compose([Validators.required, Validators.pattern('[6-9]{1}[0-9]{9}')])],

      permanantLocation: [null, Validators.compose([Validators.required, Validators.pattern(this.digitExp)])],
      currentLocation: [null, Validators.compose([Validators.required, Validators.pattern(this.digitExp)])],
      currentYear: [null, [Validators.required]],
      currentQualification: [null, [Validators.required]],
      gender: [null, [Validators.required]],
      referralName: [null, [Validators.required, Validators.pattern('[a-zA-Z ]*$')]],
      referralContactNumber: [null, Validators.compose([Validators.required, Validators.pattern('[6-9]{1}[0-9]{9}')])],
      otp: [null, Validators.compose([Validators.required])],
    });
    this.inputAutoCompleteDisable();
  }

  getCampaignData() {
    this.campaignService.getCampaignByShortname(this.campaignShortName)
      .subscribe(
        response => {
          console.log("response: ", response);

          console.log("response on register page: ", (response as any).data.campaignType);
          this.referralType = (response as any).data.campaignType;
          this.campPurpose = (response as any).data.campaignPurpose;
          console.log(" this.campPurpose :----------", this.campPurpose);

          if (this.referralType === 'HIRING_DRIVE') {
            this.isHiringDrive = true;
          }
          this.interviewMessage = (response as any).data.interviewMessage;
          this.interviewAddress = (response as any).data.interviewAddress;
          this.displayFlag = true;
        },
        error => {
          console.log("error 91--", error);
          this.router.navigate(['not-found'])

        });
  }

  inputAutoCompleteDisable() {
    setTimeout(() => {
      const inputs = document.getElementsByTagName('input');
      for (let index = 0; inputs[index]; index++) {
        const inputElement = inputs[index];
        inputElement.setAttribute('autocomplete', 'off');
      }
    }, 500);
  }

  getErrorMessage(controlName: string, alias: string) {
    const control = this.jobApplication.controls[controlName];

    if (control.errors) {
      if (control.errors.required) {
        return alias + ' is required';
      }
      if (control.errors.email) {
        return alias + ' is Invalid';

      }
      if (control.errors.minlength) {
        return alias + ' should have at least ' + control.errors.minlength.requiredLength + ' characters';
      }
      if (control.errors.pattern) {
        return 'Invalid ' + alias.toLowerCase();
      }
      if (control.errors.maxlength) {
        return alias + ' should not have more than ' + control.errors.maxlength.requiredLength + ' characters';
      }
      if (control.errors.min) {
        return alias + ' should be greater than ' + control.errors.min.min;
      }
      if (control.errors.max) {
        return alias + ' can not be greater than ' + control.errors.max.max;
      }
    }
  }
  getErrorForqualification() {
    return this.qualification.hasError('required') ? 'Qualification Cannot be blank' :
      this.qualification.hasError('pattern') ? 'Qualification must contains alphabet only' :
        this.qualification.hasError('whitespace') ? 'Please provide valid full name' :
          '';
  }
  noWhitespaceValidator(control: FormControl) {
    const isWhitespace = (control.value || '').trim().length === 0;
    const isValid = !isWhitespace;
    return isValid ? null : { 'whitespace': true };
  }

  applyJob(data) {
//  if(this.otpResendStatus === true && this.campPurpose === 'MCQ_TEST' && this.showStatusOfOtpField === true){
//   this.data = ""; 
// let options = {
//   purpose : '​/mcq​/users​/resendotp',
//   data : this.data
// }

// this.driveService.postWithTokens(options).subscribe(
//   response => {
//   console.log("response after otp resend", response);
//   this.otpResendStatus = false
//   this.utilityService.openSnackBar("OTP has been sent to your Email");
  
//   },
//   error => {
//     console.log("error after otp resend: ", error);
//     this.otpResendStatus = false
    
//   }
// )

//  } else
  if(this.campPurpose === 'MCQ_TEST' && this.showStatusOfOtpField === true){
   this.data = {
     otp: data.otp.trim()
   }

   let options = {
     purpose : '/mcq/users/verifyotp',
     data : this.data
   }

   this.driveService.postWithTokens(options).subscribe(
     response => {
     console.log("response after otp validation", response);
     },
     error => {
       console.log("error after otp: ", error);
       
     }
   )
 }
  else  if (this.campPurpose === 'MCQ_TEST') {
      this.data = {
        fullName: data.fullName.trim(),
        emailId: data.email.trim(),
        phoneNumber: data.phoneno.trim(),
        gender: data.gender,
        // campaignId: this.cid,
      }

      console.log("this.data for mcq -------->", this.data);

      let options = {
        purpose : '/mcq/users/'+this.campaignShortName , 
        data : this.data
      }
     this.driveService.postWithoutTokens(options).subscribe(
       response => {
         this.showStatusOfOtpField = true;
         console.log("response after mcq register: ", response);
         this.utilityService.openSnackBar((response as any).message)

         
       },
       error => {
        console.log("error response after mcq register: ", error);
        this.utilityService.openSnackBar(error.error.message)
       }
     ) 
      
      
      
    } else {
      try {
        if (data.phoneno.trim() === data.referralContactNumber) throw "User phone number and Referral Contact number can't be same."

        this.data = {
          fullName: data.fullName.trim(),
          emailId: data.email.trim(),
          phoneNumber: data.phoneno.trim(),
          permanentPinCode: data.permanantLocation,
          currentPinCode: data.currentLocation,
          graduationYear: data.currentYear,
          qualification: data.currentQualification == 'Others' ? this.qualification.value : data.currentQualification,
          gender: data.gender,
          campaignId: this.cid,
          referralName: this.referralType ? data.referralName : '',
          referralContactNumber: this.referralType ? data.referralContactNumber : ''
        }
        console.log("data to be sent: ", data);

        if (data != undefined) {
          this.spinnerService.show();
          var options = {
            'body': this.data,
            'purpose': `/campaign/dashboard/user/${this.campaignShortName}`
          }
          if (this.isHiringDrive) {
            this.driveService.registerUser(this.campaignShortName, this.data).subscribe(
              response => {
                console.log("after resgistration: ", response);

                this.spinnerService.hide();
                // this.openSnackBar(response["message"]);
                this.campaignService.changeMessage('registered successfully');
                this.router.navigate(['thank-you'])
                this.utilityService.openSnackBar('Registered successfully');
              }
              , error => {
                console.log("err after registration", error);
                this.spinnerService.hide();
                this.utilityService.openSnackBar(error.error.detail);
              }
            );
          } else {
            this.campaignService.postWithoutTokens(options).subscribe(
              response => {
                console.log("success ", response);
                this.spinnerService.hide();
                // console.log("i am  here");

                // this.openSnackBar(response["message"]);
                this.campaignService.changeMessage('registered successfully');
                if ((response as any).data.statusCode === -2) {
                  this.utilityService.openSnackBar((response as any).message);
                } else {
                  this.router.navigate(['thank-you'])
                  this.utilityService.openSnackBar((response as any).message);
                }

              }, error => {
                console.log("err ", error);
                this.spinnerService.hide();
                this.utilityService.openSnackBar('Error occured while registering user');
              });
          }
        }
      } catch (err) {
        this.utilityService.openSnackBar(err);
      }
    }
  }

  findUserDetails() {

    // if (this.email != null  &&  this.email.valid){
    console.log("this.emailvalue data: ", this.jobApplication.controls['email'].value
    );
    // console.log("focus off");
    let selectedEmail = this.jobApplication.controls['email'].value.trim();
    // console.log("email required: ", selectedEmail);
    let options = {
      purpose: '/users/' + selectedEmail
    }
    //   if (selectedEmail != '') {
    this.driveService.getWithoutTokens(options).subscribe(
      response => {
        console.log("response after service: ", (response as any));
        this.data = (response as any).data;
        console.log("data after finding details: ", this.data);
        if( (response as any).data != "")
        this.jobApplication.patchValue({
          email: this.data.emailId,
          phoneno: this.data.phoneNumber,
          fullName: this.data.fullName,
          gender: this.data.gender
        });
      },
      error => {
        console.log("error after service call:142 ", error);
        this.utilityService.openSnackBar('Error while retrieving user data');
      }
    )
  }

  resend(){
    console.log("called");
    
    this.otpResendStatus = true;
    this.data = ""; 
let options = {
  purpose : '​/mcq​/users​/resendotp',
  data : this.data
}
console.log("options for resend: ", options);

this.driveService.postWithTokens(options).subscribe(
  response => {
  console.log("response after otp resend", response);
  this.otpResendStatus = false
  this.utilityService.openSnackBar("OTP has been sent to your Email");
  
  },
  error => {
    console.log("error after otp resend: ", error);
    this.otpResendStatus = false
    
  }
)
  }
}
